import { EYEBROW_CLASS } from "../lib/ui.js";

export const TONE = {
    OK: "ok",
    WAITING: "waiting",
    ATTENTION: "attention",
    SETUP: "setup",
    LOADING: "loading",
    UNAVAILABLE: "unavailable",
};

const btnBase =
    "inline-flex h-[32px] shrink-0 items-center justify-center whitespace-nowrap rounded-[2px] border px-[12px] text-[11px] leading-[1.08] font-medium uppercase tracking-[0.04em] cursor-pointer disabled:cursor-not-allowed disabled:opacity-50";

export const primaryBtnCls = `${btnBase} border-[color:var(--ink)] bg-[color:var(--ink)] text-[color:var(--bg)] hover:opacity-90`;
export const secondaryBtnCls = `${btnBase} border-[color:var(--line-strong)] bg-transparent text-[color:var(--ink)] hover:border-[color:var(--ink)]`;
export const ghostBtnCls = `${btnBase} border-transparent bg-transparent text-[color:var(--muted)] hover:text-[color:var(--ink)]`;
export const dangerBtnCls = `${btnBase} border-[color:var(--severity-high)] bg-transparent text-[color:var(--severity-high)] hover:bg-[color:var(--gray-fill)]`;

const TONE_STYLE = {
    [TONE.OK]: { pill: "bg-[color:var(--green-soft)] text-[color:var(--ink)]", dot: "bg-[color:var(--green)]" },
    [TONE.WAITING]: { pill: "bg-[color:var(--gray-fill)] text-[color:var(--ink)]", dot: "bg-[color:var(--severity-medium)]" },
    [TONE.ATTENTION]: {
        pill: "bg-[color:color-mix(in_srgb,var(--severity-high)_14%,transparent)] text-[color:var(--ink)]",
        dot: "bg-[color:var(--severity-high)]",
    },
    [TONE.SETUP]: { pill: "bg-[color:var(--gray-fill)] text-[color:var(--muted)]", dot: "bg-[color:var(--line-strong)]" },
    [TONE.LOADING]: { pill: "bg-[color:var(--gray-fill)] text-[color:var(--muted)]", dot: "bg-[color:var(--line)]" },
    [TONE.UNAVAILABLE]: { pill: "bg-[color:var(--gray-fill)] text-[color:var(--muted)]", dot: "bg-[color:var(--line-strong)]" },
};

export function toneDotClass(tone) {
    return (TONE_STYLE[tone] ?? TONE_STYLE[TONE.SETUP]).dot;
}

export function StatusPill({ tone, label, pulse = false }) {
    const style = TONE_STYLE[tone] ?? TONE_STYLE[TONE.SETUP];
    return (
        <span
            className={`inline-flex shrink-0 items-center gap-[6px] whitespace-nowrap rounded-[2px] px-[8px] py-[3px] text-[11px] font-medium leading-[1.2] ${style.pill}`}
        >
            <span aria-hidden="true" className={`h-[7px] w-[7px] rounded-full ${style.dot} ${pulse ? "animate-pulse" : ""}`} />
            {label}
        </span>
    );
}

export function SourceLogo({ logo, size = 28, muted = false }) {
    if (!logo) return null;
    return (
        <svg
            viewBox={logo.viewBox}
            aria-hidden="true"
            className={`shrink-0 ${muted ? "text-[color:var(--muted)]" : "text-[color:var(--ink)]"}`}
            style={{ width: size, height: size }}
            xmlns="http://www.w3.org/2000/svg"
        >
            {logo.paths.map((d, index) => (
                <path key={index} d={d} fill="currentColor" />
            ))}
        </svg>
    );
}

export function Fact({ label, children, tone = null }) {
    const color =
        tone === "warning"
            ? "text-[color:var(--severity-medium)]"
            : tone === "muted"
              ? "text-[color:var(--muted)]"
              : "text-[color:var(--ink)]";
    return (
        <div className="grid min-w-0 gap-[3px]">
            <dt className={EYEBROW_CLASS}>{label}</dt>
            <dd className={`m-0 truncate text-[13px] ${color}`}>{children}</dd>
        </div>
    );
}
